import React from 'react';
import { IInstrumentationContext } from './types';

const defaultImpl: IInstrumentationContext = {} as IInstrumentationContext;
export const InstrumentationContext = React.createContext<IInstrumentationContext>(defaultImpl);
